if (!customElements.get('tt-customize')) {
  customElements.define('tt-customize', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const tabs = [...this.querySelectorAll('[data-custom-tab]')];
      const panels = [...this.querySelectorAll('[data-custom-panel]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activate(tab);
        }, options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        }, options);
      });
      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[data-custom-panel]');
          const tab = tabs.find((item) => item.getAttribute('aria-controls') === panel?.id);
          if (tab) activate(tab);
          const details = event.target.closest('details');
          if (details) details.open = true;
          event.target.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, options);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
